/*
  Product page module (Abdul, 2026-09-25), loaded by sections/ca-pdp.liquid:
  the approved "previous" design with the turn 13b color list, and the
  turn 14 deal types drawn from the Kaching deal on the page (tier tags,
  savings line, add-ons and gifts). Kaching stays the discount engine; this
  file only shows its deal and, when an add-on or gift is chosen, writes
  Kaching's line tag so those discounts apply. Runs in this theme and inside
  a copy of Sleek, where the cart drawer and header count are Sleek's.
*/
class CAProductForm extends HTMLElement {
  connectedCallback() {
    var jsonEl = this.querySelector('[data-ca-variant-json]');
    try {
      this.variantsData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (e) {
      this.variantsData = [];
    }

    var initialId = this.getAttribute('data-initial-variant-id');
    this.state = {
      variantId: initialId ? parseInt(initialId, 10) : (this.variantsData[0] && this.variantsData[0].id),
      selectedOptions: []
    };
    var initialVariant = this.getVariant();
    if (initialVariant && initialVariant.options) {
      this.state.selectedOptions = initialVariant.options.slice();
    }

    this.form = this.querySelector('.ca-pdp__form');
    this.variantInput = this.querySelector('[data-ca-variant-input]');
    this.priceEl = this.querySelector('[data-ca-price-current]');
    this.compareEl = this.querySelector('[data-ca-price-compare]');
    this.inventoryEl = this.querySelector('[data-ca-inventory]');
    this.atcBtn = this.querySelector('[data-ca-atc]');
    this.buyNowBtn = this.querySelector('[data-ca-buy-now]');
    this.dynamicEl = this.querySelector('[data-ca-dynamic]');
    this.formQty = this.querySelector('[data-ca-form-qty]');
    this.stickyBtn = this.querySelector('[data-ca-sticky-atc]');
    this.stickyBar = this.querySelector('[data-ca-sticky-bar]');
    this.stickyPrice = this.querySelector('[data-ca-sticky-price]');
    this.traySheet = this.querySelector('[data-ca-tray-sheet]');
    this.trayAtc = this.querySelector('[data-ca-tray-atc]');
    this.trayBuy = this.querySelector('[data-ca-tray-buy]');
    this.qtyInput = this.querySelector('[data-ca-qty-input]');
    this.galleryMain = this.querySelector('[data-ca-gallery-main]');

    this.moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
    this.productId = parseInt(this.getAttribute('data-product-id'), 10) || 0;
    this.productHandle = this.getAttribute('data-product-handle') || '';
    this.noun = this.getAttribute('data-unit-noun') || 'item';
    this.colourSet = this.hasAttribute('data-colour-set');
    // Turn 16b trial (?view=ca-card): one purchase card, with a line from
    // the first item for every product, so the list is used for all.
    this.cardLayout = this.hasAttribute('data-layout-card');
    this.listMode = this.colourSet || this.cardLayout;
    this.set = {};
    this.setOrder = [];
    // The Kaching deal for this product (turn 14), or null: then the page
    // is a plain product page and shows no tags, savings or add-ons.
    this.deal = this.readDeal();
    this.extras = { barId: null, checked: {}, choice: {} };
    if (this.listMode) this.bindColourSet();
    this.bindDealExtras();
    this.bindRecs();
    this.bindAdded();

    this.bindVariantInputs();
    this.bindQty();
    this.bindAtc();
    this.bindGallery();
    this.bindExpander();
    this.bindStickyObserver();
    this.bindZoom();
    this.bindTray();
    caRelabelBuyNow(this);
    this.render();
    // Restock Rocket loads on its own schedule; tell it the color on show
    // once it is there.
    var self = this;
    var tries = 0;
    var wait = setInterval(function () {
      tries += 1;
      if (window._RestockRocket || tries > 40) { clearInterval(wait); self.syncRestock(); }
    }, 250);
  }

  // Two options (color and size, 2026-09-26): each value is checked against
  // the other option picked. Not available in that combination (sold out,
  // or not made) is greyed and moves to the end of its row (Abdul); sold
  // out stays tappable for Notify me, not made is not tappable. Available
  // values keep their order (new colors first).
  syncOptionStates() {
    var v = this.getVariant();
    if (!v || !v.options || v.options.length < 2) return;
    var self = this;
    var rows = {};
    this.querySelectorAll('[data-option-position]').forEach(function (input, index) {
      var pos = parseInt(input.getAttribute('data-option-position'), 10);
      var want = v.options.slice();
      want[pos] = input.value;
      var match = null;
      for (var i = 0; i < self.variantsData.length; i++) {
        var o = self.variantsData[i].options || [];
        if (o.length === want.length && o.every(function (x, j) { return x === want[j]; })) { match = self.variantsData[i]; break; }
      }
      var label = self.querySelector('label[for="' + input.id + '"]');
      input.disabled = !match;
      if (!input.hasAttribute('data-order')) input.setAttribute('data-order', index);
      if (label) {
        label.classList.toggle('is-combo-missing', !match);
        label.classList.toggle('is-combo-soldout', !!(match && !match.available));
        if (!match) label.setAttribute('aria-disabled', 'true'); else label.removeAttribute('aria-disabled');
      }
      // Swatches sit in their own li; text options are input and label pairs.
      var li = input.closest('li');
      var unit = li ? [li] : (label ? [input, label] : [input]);
      var parent = unit[0].parentNode;
      (rows[pos] = rows[pos] || { parent: parent, units: [] }).units.push({
        nodes: unit,
        off: !match || !match.available ? 1 : 0,
        order: parseInt(input.getAttribute('data-order'), 10)
      });
    });
    Object.keys(rows).forEach(function (pos) {
      var row = rows[pos];
      var sorted = row.units.slice().sort(function (a, b) { return a.off - b.off || a.order - b.order; });
      var changed = sorted.some(function (u, i) { return u !== row.units[i]; });
      if (!changed) return;
      // Keep anything after the values (the Show all tile) at the end.
      var tail = row.parent.querySelector('.ca-variant-picker__more-item');
      sorted.forEach(function (u) { u.nodes.forEach(function (n) { row.parent.insertBefore(n, tail); }); });
      // Desktop shows the first few swatches before the Show all tile: keep
      // that count, now over the new order.
      var items = Array.prototype.slice.call(row.parent.querySelectorAll('.ca-variant-picker__item:not(.ca-variant-picker__more-item)'));
      if (!items.length) return;
      if (!row.parent.hasAttribute('data-visible-max')) {
        row.parent.setAttribute('data-visible-max', items.filter(function (li) { return !li.classList.contains('ca-variant-picker__item--extra'); }).length);
      }
      var max = parseInt(row.parent.getAttribute('data-visible-max'), 10);
      items.forEach(function (li, i) { li.classList.toggle('ca-variant-picker__item--extra', i >= max); });
    });
  }

  // Back-in-stock (Abdul, 2026-09-25): a sold-out color can be tapped; this
  // tells Restock Rocket which color is on show so it shows its sign-up
  // form for a sold-out one and removes it for one in stock.
  syncRestock() {
    var rr = window._RestockRocket;
    var v = this.getVariant();
    if (!rr || !v || typeof rr.renderButtonForVariant !== 'function') return;
    try { rr.renderButtonForVariant(v.id); } catch (e) {}
  }


  variantById(id) {
    for (var i = 0; i < this.variantsData.length; i++) {
      if (this.variantsData[i].id === id) return this.variantsData[i];
    }
    return null;
  }

  addToSet(id) {
    if (!this.set[id]) {
      this.set[id] = 0;
      this.setOrder.push(id);
    }
    this.set[id] += 1;
  }

  removeFromSet(id) {
    if (!this.set[id]) return;
    this.set[id] -= 1;
    if (this.set[id] <= 0) {
      delete this.set[id];
      this.setOrder = this.setOrder.filter(function (x) { return x !== id; });
    }
  }

  setLines() {
    var self = this;
    return this.setOrder.map(function (id) {
      return { id: id, quantity: self.set[id], variant: self.variantById(id) };
    }).filter(function (l) { return l.variant && l.variant.available; });
  }

  // Multi-buy saving (Abdul, 2026-09-24), from the section's tiers
  // (data-offer "3:10,4:15"). It mirrors the live discount as verified in
  // the cart: T-Pex lines count together across colors, and each unit loses
  // a whole-cent amount rounded down ($6.95 at 15% = $1.04 off).

  escapeText(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (this.moneyFormat || '${{amount}}')
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount}}', whole + '.' + parts[1]);
  }

  bindColourSet() {
    var self = this;
    this.sheet = this.querySelector('[data-ca-set-sheet]');
    // New colors (Abdul, 2026-09-24): new_until is set by Flow to the day
    // a color was added + 30 days; data-today is the store's date.
    var today = this.getAttribute('data-today') || '';
    this.variantsData.forEach(function (v) {
      v.is_new = !!(v.available && v.new_until && today && v.new_until >= today);
    });
    // The sheet lists new colors first, like the swatches.
    var list = this.sheet && this.sheet.querySelector('.ca-set-sheet__list');
    if (list) {
      var self0 = this;
      Array.prototype.slice.call(list.querySelectorAll('[data-ca-set-row]')).reverse().forEach(function (row) {
        var v = self0.variantById(parseInt(row.getAttribute('data-variant-id'), 10));
        if (v && v.is_new) {
          list.insertBefore(row, list.firstChild);
          var name = row.querySelector('.ca-set-sheet__name');
          if (name && !name.querySelector('.ca-variant-picker__new')) name.insertAdjacentHTML('beforeend', ' <span class="ca-set-sheet__new">New</span>');
        }
      });
    }
    this.querySelectorAll('[data-ca-set-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.openSheet(btn); });
    });
    if (this.sheet) {
      this.sheet.addEventListener('click', function (e) {
        if (e.target === self.sheet) { self.closeSheet(); return; }
        if (e.target.closest('[data-ca-set-done]')) { self.closeSheet(); return; }
        var sizeBtn = e.target.closest('[data-ca-sheet-size]');
        if (sizeBtn) { self.filterSheet(sizeBtn.getAttribute('data-ca-sheet-size')); return; }
        var row = e.target.closest('[data-ca-set-row]');
        if (!row) return;
        var id = parseInt(row.getAttribute('data-variant-id'), 10);
        if (e.target.closest('[data-ca-set-inc]')) { self.addToSet(id); self.render(); }
        else if (e.target.closest('[data-ca-set-dec]')) { self.removeFromSet(id); self.render(); }
      });
      this.sheet.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); self.closeSheet(); }
      });
    }
    // The list (turn 13b): minus, plus and remove per color. Removing the
    // last color goes back to one color and a quantity of 1.
    var lines = this.querySelector('[data-ca-set-lines]');
    if (lines) {
      lines.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-id]');
        if (!btn) return;
        var id = parseInt(btn.getAttribute('data-line-id'), 10);
        if (btn.hasAttribute('data-line-inc')) {
          if ((self.set[id] || 0) < self.maxQty(self.variantById(id))) self.addToSet(id);
        } else if (btn.hasAttribute('data-line-dec')) {
          if ((self.set[id] || 0) > 1) self.removeFromSet(id);
        } else if (btn.hasAttribute('data-line-remove')) {
          delete self.set[id];
          self.setOrder = self.setOrder.filter(function (x) { return x !== id; });
          if (!self.setOrder.length && self.qtyInput) self.qtyInput.value = 1;
        }
        self.render();
        var sel = btn.hasAttribute('data-line-remove') ? '[data-line-remove]' : '[data-line-id="' + id + '"][' + (btn.hasAttribute('data-line-inc') ? 'data-line-inc' : 'data-line-dec') + ']';
        var next = lines.querySelector(sel) || self.querySelector('[data-ca-qty-row]:not([hidden]) [data-ca-qty-input]');
        if (next) next.focus();
      });
    }
  }

  // Most of one color a shopper can add: Shopify's count when it tracks
  // stock, otherwise a sane cap.

  maxQty(v) {
    if (v && v.inventory_management === 'shopify' && v.inventory_quantity > 0) return Math.min(99, v.inventory_quantity);
    return 99;
  }

  // One color and a quantity becomes the list once a second lure or a
  // second color is wanted (turn 13b).

  seedSet(qty) {
    var v = this.getVariant();
    if (!v || !v.available || this.setOrder.length) return;
    this.set = {};
    this.set[v.id] = Math.min(this.maxQty(v), Math.max(1, qty || 1));
    this.setOrder = [v.id];
  }

  openSheet(opener) {
    if (!this.sheet || typeof this.sheet.showModal !== 'function') return;
    this.sheetOpener = opener || null;
    // The sheet starts from what is already chosen: the color on show at
    // its quantity, or the list as it stands.
    this.seedSet(this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1);
    // Two options (color and size): the sheet opens on the size on show.
    var v = this.getVariant();
    if (v && v.options && v.options.length > 1) this.filterSheet(v.options[1]);
    this.renderColourSet();
    this.sheet.showModal();
  }

  // Lists the colors in one size; quantities in other sizes stay in the set.
  filterSheet(size) {
    if (!this.sheet) return;
    this.sheet.querySelectorAll('[data-ca-set-row]').forEach(function (row) {
      var r = row.getAttribute('data-rest');
      row.hidden = r !== null && r.split('|')[0] !== size;
    });
    this.sheet.querySelectorAll('[data-ca-sheet-size]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-ca-sheet-size') === size ? 'true' : 'false');
    });
  }

  closeSheet() {
    if (!this.sheet || !this.sheet.open) return;
    this.sheet.close();
    // The opener may be hidden now (the stepper row gives way to the set
    // box), so return focus to whichever set control is visible.
    var target = this.querySelector('[data-ca-set-box]:not([hidden]) [data-ca-set-open]') || this.sheetOpener;
    if (target) target.focus();
  }

  /*
    Kaching deal (turn 14, Abdul, 2026-09-25). Kaching's app embed prints the
    deal as JSON on the page; this reads it rather than keeping a second copy
    of the tiers in the theme. Only the deal shapes verified against the live
    cart on 2026-09-25 are drawn: quantity breaks at a percentage or a set
    price for the quantity, and buy X get Y at a percentage off the Y items.
    Any other shape (or a deal that does not let colors mix, on a color
    product) returns null, so the page never states a saving it cannot
    check; Kaching still applies its discount in the cart.
  */
  readDeal() {
    var pid = String(this.productId);
    var el = null;
    document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(function (s) {
      if (!el && s.getAttribute('data-product-id') === pid && s.textContent.trim()) el = s;
    });
    if (!el) return null;
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!d || !Array.isArray(d.dealBars) || !d.dealBars.length) return null;
    if (this.colourSet && d.differentVariantsEnabled === false) return null;
    var bars = [];
    for (var i = 0; i < d.dealBars.length; i++) {
      var b = d.dealBars[i];
      var bar = { id: b.id, upsells: b.upsells || [], gifts: b.freeGifts || [] };
      var type = b.dealBarType || 'quantity-break';
      if (type === 'quantity-break') {
        bar.threshold = parseInt(b.quantity, 10) || 0;
        var value = parseFloat(b.discountValue) || 0;
        if (b.discountType === 'percentage' && value > 0 && value <= 100) { bar.kind = 'pct'; bar.value = value; }
        else if (b.discountType === 'specific' && value > 0) { bar.kind = 'price'; bar.value = value; }
        else if (!b.discountType || b.discountType === 'default' || !value) { bar.kind = 'none'; }
        else return null;
      } else if (type === 'bxgy') {
        bar.buy = parseInt(b.buyQuantity, 10) || 0;
        bar.get = parseInt(b.getQuantity, 10) || 0;
        bar.threshold = bar.buy + bar.get;
        var gv = parseFloat(b.getDiscountValue) || 0;
        var bv = parseFloat(b.buyDiscountValue) || 0;
        if (b.getDiscountType !== 'percentage' || gv <= 0 || gv > 100 || bv || !bar.buy || !bar.get) return null;
        bar.kind = 'free';
        bar.value = gv;
      } else {
        return null;
      }
      if (bar.threshold < 1) return null;
      bars.push(bar);
    }
    bars.sort(function (a, b) { return a.threshold - b.threshold; });
    var products = {};
    document.querySelectorAll('script.kaching-bundles-product').forEach(function (s) {
      try {
        var p = JSON.parse(s.textContent);
        if (p && p.id) products[p.id] = p;
      } catch (e) {}
    });
    var paid = bars.filter(function (b) { return b.kind !== 'none'; });
    var extras = bars.some(function (b) { return b.upsells.length || b.gifts.length; });
    if (!paid.length && !extras) return null;
    return {
      id: d.nanoId || d.id,
      version: d.versionId || null,
      mixed: d.differentVariantsEnabled !== false,
      bars: bars,
      paid: paid,
      products: products
    };
  }

  // The deal step a quantity reaches: the step with the highest threshold at
  // or below it. Kaching picks by threshold, not by value (verified: 6
  // Uncle Larry's get one free, not $5 each).
  barFor(qty) {
    var hit = null;
    (this.deal ? this.deal.bars : []).forEach(function (b) { if (qty >= b.threshold) hit = b; });
    return hit;
  }

  // Saving in cents for unit prices (cents) under a step, mirroring the
  // cart: each unit's percentage is rounded down to the cent; a set price
  // lowers each unit to price / quantity; buy X get Y takes Y of the
  // cheapest units once, not per group.
  savingFor(bar, units) {
    if (!bar || units.length < bar.threshold) return 0;
    if (bar.kind === 'pct') {
      return units.reduce(function (t, p) { return t + Math.floor(p * bar.value / 100); }, 0);
    }
    if (bar.kind === 'price') {
      var each = Math.round(bar.value * 100 / bar.threshold);
      return units.reduce(function (t, p) { return t + Math.max(0, p - each); }, 0);
    }
    if (bar.kind === 'free') {
      return units.slice().sort(function (a, b) { return a - b; }).slice(0, bar.get)
        .reduce(function (t, p) { return t + Math.floor(p * bar.value / 100); }, 0);
    }
    return 0;
  }

  unitsOf(lines) {
    var units = [];
    lines.forEach(function (l) { for (var i = 0; i < l.quantity; i++) units.push(l.price); });
    return units;
  }

  // A line's name: the variant, or the product itself when it has no
  // variants (Shopify calls that one "Default Title").
  lineName(v) {
    return v.title === 'Default Title' ? (this.getAttribute('data-product-title') || v.title) : v.title;
  }

  // Where the main product's lines stand: the step reached, its saving, and
  // the next step worth naming (one that saves more than staying put would
  // at that quantity; at 5 Uncle Larry's a free spinner saves nothing over
  // $5 each, so it is not teased).
  dealState(lines) {
    var units = this.unitsOf(lines);
    var qty = units.length;
    var bar = this.barFor(qty);
    var saving = this.savingFor(bar, units);
    var next = null;
    var v = this.getVariant();
    var pad = v ? v.price : (units[0] || 0);
    var self = this;
    (this.deal ? this.deal.paid : []).forEach(function (b) {
      if (next || b.threshold <= qty) return;
      var padded = units.slice();
      while (padded.length < b.threshold) padded.push(pad);
      if (self.savingFor(b, padded) > self.savingFor(bar, padded)) next = b;
    });
    return { qty: qty, bar: bar, saving: bar && bar.kind !== 'none' ? saving : 0, next: next };
  }

  plural(n) {
    var w = this.noun;
    if (n === 1) return w;
    if (/(s|x|ch|sh)$/.test(w)) return w + 'es';
    if (/[^aeiou]y$/.test(w)) return w.slice(0, -1) + 'ies';
    return w + 's';
  }

  moneyShort(cents) {
    var m = this.formatMoney(cents);
    return cents % 100 === 0 ? m.replace(/\.00(?=\D*$)/, '') : m;
  }

  tagText(bar) {
    var last = this.deal.paid[this.deal.paid.length - 1] === bar;
    if (bar.kind === 'pct') return 'Buy ' + bar.threshold + (last ? '+' : '') + ', save ' + bar.value + '%';
    if (bar.kind === 'price') return bar.threshold + ' for ' + this.moneyShort(Math.round(bar.value * 100));
    if (bar.value >= 100) return 'Buy ' + bar.buy + ', get ' + bar.get + ' free';
    return 'Buy ' + bar.buy + ', get ' + bar.get + ' at ' + bar.value + '% off';
  }

  // "Add 1 more for 15% off", "Add 2 more and 1 is free", "Add 1 more rod
  // and it is free".
  nextText(bar, need) {
    if (bar.kind === 'pct') return 'Add ' + need + ' more for ' + bar.value + '% off';
    if (bar.kind === 'price') return 'Add ' + need + ' more: ' + bar.threshold + ' for ' + this.moneyShort(Math.round(bar.value * 100));
    if (bar.value < 100) return 'Add ' + need + ' more for ' + bar.get + ' at ' + bar.value + '% off';
    if (need === 1 && bar.get === 1) return 'Add 1 more ' + this.noun + ' and it is free';
    return 'Add ' + need + ' more and ' + bar.get + (bar.get === 1 ? ' is' : ' are') + ' free';
  }

  // The savings line (turn 14): what applies now, then what the next step
  // gives or what the shopper saves.
  savingText(st) {
    var bar = st.bar;
    if (st.saving > 0) {
      var now;
      if (bar.kind === 'pct') now = bar.value + '% off applied';
      else if (bar.kind === 'price') now = bar.threshold + ' for ' + this.moneyShort(Math.round(bar.value * 100)) + ' applied: ' + this.moneyShort(Math.round(bar.value * 100 / bar.threshold)) + ' each';
      else if (bar.value >= 100) now = (bar.get === 1 ? 'Free ' + this.noun : bar.get + ' free ' + this.plural(bar.get)) + ' applied';
      else now = bar.value + '% off ' + bar.get + ' ' + this.plural(bar.get) + ' applied';
      if (st.next) return now + '. ' + this.nextText(st.next, st.next.threshold - st.qty) + '.';
      if (bar.kind === 'price') return now + '.';
      return now + ': you save ' + this.formatMoney(st.saving);
    }
    if (st.next && st.qty >= 1) return this.nextText(st.next, st.next.threshold - st.qty) + '.';
    return '';
  }

  // The card footer's shorter line (turn 15a): "10% off. 1 more for 15%."
  shortSavingText(st) {
    var bar = st.bar;
    var money = this.moneyShort.bind(this);
    var next = function (b, need) {
      if (b.kind === 'pct') return need + ' more for ' + b.value + '%';
      if (b.kind === 'price') return need + ' more: ' + b.threshold + ' for ' + money(Math.round(b.value * 100));
      if (b.value < 100) return need + ' more for ' + b.get + ' at ' + b.value + '% off';
      return need + ' more and ' + b.get + (b.get === 1 ? ' is' : ' are') + ' free';
    };
    if (st.saving > 0) {
      var now;
      if (bar.kind === 'pct') now = bar.value + '% off';
      else if (bar.kind === 'price') now = bar.threshold + ' for ' + money(Math.round(bar.value * 100)) + ': ' + money(Math.round(bar.value * 100 / bar.threshold)) + ' each';
      else if (bar.value >= 100) now = bar.get === 1 ? 'Free ' + this.noun : bar.get + ' free ' + this.plural(bar.get);
      else now = bar.value + '% off ' + bar.get;
      if (st.next) return now + '. ' + next(st.next, st.next.threshold - st.qty) + '.';
      if (bar.kind === 'price') return now + '.';
      return now + ': you save ' + this.formatMoney(st.saving);
    }
    if (st.next && st.qty >= 1) return 'Add ' + next(st.next, st.next.threshold - st.qty) + '.';
    return '';
  }

  // The whole offer in one sentence (turn 17c): "Save 10% on 3, 15% on 4
  // or more", "Save 15% on 3 · Buy 4, get 1 free", "3 for $15 · Buy 4, get
  // 1 free".
  offerText() {
    var self = this;
    var out = [];
    var paid = this.deal ? this.deal.paid : [];
    paid.forEach(function (b, i) {
      var last = i === paid.length - 1;
      if (b.kind === 'pct') {
        var part = b.value + '% on ' + b.threshold + (last ? ' or more' : '');
        if (out.length && paid[i - 1].kind === 'pct') out[out.length - 1] += ', ' + part;
        else out.push('Save ' + part);
      } else if (b.kind === 'price') {
        out.push(b.threshold + ' for ' + self.moneyShort(Math.round(b.value * 100)));
      } else {
        out.push(self.tagText(b));
      }
    });
    return out.join(' · ');
  }

  // Card head (turn 17c): the bold line is the next step, the green line
  // what the selection already gets; at the top step the green line alone.
  renderCardDeal(st) {
    var self = this;
    this.querySelectorAll('[data-ca-deal-head]').forEach(function (el) { self.renderDealHead(el, st); });
  }

  // One deal head (the card's, or the color sheet's): same sentence in both.
  renderDealHead(headEl, st) {
    var on = !!(this.deal && this.deal.paid.length);
    headEl.hidden = !on;
    if (!on) return;
    var bar = st.bar;
    var got = '';
    if (st.saving > 0) {
      if (bar.kind === 'pct') got = bar.value + '% off applied';
      else if (bar.kind === 'price') got = bar.threshold + ' for ' + this.moneyShort(Math.round(bar.value * 100)) + ' applied: ' + this.moneyShort(Math.round(bar.value * 100 / bar.threshold)) + ' each';
      else if (bar.value >= 100) got = (bar.get === 1 ? 'Free ' + this.noun : bar.get + ' free ' + this.plural(bar.get)) + ' applied';
      else got = bar.value + '% off ' + bar.get + ' ' + this.plural(bar.get) + ' applied';
      if (bar.kind !== 'price') got += ': you save ' + this.formatMoney(st.saving);
    }
    var next, sub = got, subIsGot = !!got;
    if (st.next && st.qty >= 2) {
      next = this.nextText(st.next, st.next.threshold - st.qty) + '.';
    } else if (st.next) {
      next = this.offerText();
      if (!got) { sub = this.colourSet && this.deal.mixed ? 'Mix any colors.' : ''; subIsGot = false; }
    } else {
      next = got;
      sub = '';
    }
    var best = st.saving > 0 && !st.next;
    var nextEl = headEl.querySelector('[data-ca-card-next]');
    var gotEl = headEl.querySelector('[data-ca-card-got]');
    nextEl.textContent = next;
    nextEl.classList.toggle('is-got', best);
    gotEl.textContent = sub;
    gotEl.hidden = !sub;
    gotEl.classList.toggle('is-got', subIsGot);
    headEl.classList.toggle('is-best', best);
  }

  renderDealTags(qty) {
    var self = this;
    var st = this.deal ? this.dealState([{ quantity: qty, price: 0 }]) : null;
    this.querySelectorAll('[data-ca-deal-tags]').forEach(function (box) {
      if (!self.deal || !self.deal.paid.length) { box.hidden = true; return; }
      if (!box.childElementCount) {
        self.deal.paid.forEach(function (bar) {
          var tag = document.createElement('span');
          tag.className = 'ca-offer__tag';
          tag.setAttribute('data-bar', bar.id);
          tag.textContent = self.tagText(bar);
          box.appendChild(tag);
        });
        if (self.colourSet && self.deal.mixed) {
          var note = document.createElement('span');
          note.className = 'ca-offer__note';
          note.textContent = 'Mix any colors';
          box.appendChild(note);
        }
      }
      box.querySelectorAll('[data-bar]').forEach(function (tag) {
        tag.classList.toggle('is-reached', !!(st && st.bar && st.bar.kind !== 'none' && tag.getAttribute('data-bar') === st.bar.id));
      });
      box.hidden = false;
    });
  }

  // Writes the savings line, bar and total into a box (the color list's or
  // the deal line under the stepper). total: the main lines at full price.
  renderSaving(st, total, textEl, wrapEl, barEl, totalEl) {
    var text = this.deal ? this.savingText(st) : '';
    if (wrapEl) {
      wrapEl.hidden = !text || (st.qty < 2 && !st.saving);
      wrapEl.classList.toggle('is-best', st.saving > 0 && !st.next);
      if (textEl) textEl.textContent = text;
      var top = this.deal && this.deal.paid.length ? this.deal.paid[this.deal.paid.length - 1].threshold : 1;
      if (barEl) barEl.style.width = Math.min(100, Math.round(st.qty / top * 100)) + '%';
    }
    if (totalEl) {
      totalEl.textContent = '';
      if (st.saving) {
        var was = document.createElement('s');
        was.className = 'ca-set-list__was';
        was.textContent = this.formatMoney(total);
        totalEl.appendChild(was);
      }
      var now = document.createElement('b');
      now.textContent = this.formatMoney(total - st.saving);
      totalEl.appendChild(now);
    }
  }

  // Which list line shows the free unit of a buy X get Y step: the cheapest
  // line, the last one on a tie. Its price shows less that unit.
  freeLineId(lines, st) {
    if (!st.bar || st.bar.kind !== 'free' || !st.saving) return null;
    var pick = null;
    lines.forEach(function (l) { if (!pick || l.variant.price <= pick.variant.price) pick = l; });
    return pick ? pick.id : null;
  }

  renderColourSet() {
    var self = this;
    if (this.cardLayout && this.soldView) { this.renderSoldLine(); return; }
    var lines = this.setLines();
    var count = lines.reduce(function (t, l) { return t + l.quantity; }, 0);
    var total = lines.reduce(function (t, l) { return t + l.quantity * l.variant.price; }, 0);
    var words = count + ' ' + this.plural(count) + ' · ' + lines.length + (lines.length === 1 ? ' color' : ' colors');

    var box = this.querySelector('[data-ca-set-box]');
    // The card hides only when nothing can be bought (every color sold out).
    if (box) box.hidden = count === 0;
    var qtyRow = this.querySelector('[data-ca-qty-row]');
    if (qtyRow) qtyRow.hidden = count > 0;
    var st = this.dealState(lines.map(function (l) { return { quantity: l.quantity, price: l.variant.price }; }));
    var saving = this.querySelector('[data-ca-set-saving]');
    var barWrap = this.querySelector('[data-ca-set-barwrap]');
    if (saving) {
      var text = this.deal ? this.shortSavingText(st) : '';
      saving.hidden = !text;
      saving.querySelector('[data-ca-set-saving-text]').textContent = text;
      if (box) box.classList.toggle('is-best', st.saving > 0 && !st.next);
    }
    if (barWrap) {
      var top = this.deal && this.deal.paid.length ? this.deal.paid[this.deal.paid.length - 1].threshold : 0;
      barWrap.hidden = !top || !saving || saving.hidden;
      barWrap.querySelector('[data-ca-set-bar]').style.width = top ? Math.min(100, Math.round(st.qty / top * 100)) + '%' : '0';
    }
    var freeId = this.freeLineId(lines, st);
    this.renderCardDeal(st);
    var single = this.cardLayout && lines.length === 1;

    var listEl = this.querySelector('[data-ca-set-lines]');
    if (listEl) {
      listEl.textContent = '';
      lines.forEach(function (l) {
        var li = document.createElement('li');
        li.className = 'ca-set-line';
        var thumb = document.createElement('span');
        thumb.className = 'ca-set-line__thumb';
        if (l.variant.thumb) {
          var img = document.createElement('img');
          img.src = l.variant.thumb;
          img.alt = '';
          img.width = 40;
          img.height = 40;
          thumb.appendChild(img);
        }
        li.appendChild(thumb);
        var name = document.createElement('span');
        name.className = 'ca-set-line__name';
        name.textContent = self.lineName(l.variant);
        // The free unit (Abdul, 2026-09-25): a line that is wholly free
        // carries the FREE tag; a line where only some are free says
        // "1 of 6 free" and shows its full price struck through, so the
        // whole line never reads as free.
        var partFree = l.id === freeId && l.quantity > st.bar.get;
        // The card shows each line after its deal saving (turn 16b).
        var cardSave = 0;
        if (self.cardLayout && st.saving && st.bar) {
          if (st.bar.kind === 'pct') cardSave = l.quantity * Math.floor(l.variant.price * st.bar.value / 100);
          else if (st.bar.kind === 'price') cardSave = l.quantity * Math.max(0, l.variant.price - Math.round(st.bar.value * 100 / st.bar.threshold));
          else if (l.id === freeId) cardSave = st.saving;
        }
        if (l.id === freeId && !partFree) {
          var free = document.createElement('span');
          free.className = 'ca-free-tag';
          free.textContent = 'Free';
          name.appendChild(free);
        } else if (partFree) {
          var note = document.createElement('span');
          note.className = 'ca-set-line__free';
          note.textContent = st.bar.get + ' of ' + l.quantity + ' free';
          name.appendChild(note);
        }
        li.appendChild(name);
        var max = self.maxQty(l.variant);
        var t = self.escapeText(self.lineName(l.variant));
        var step = document.createElement('span');
        step.className = 'ca-set-line__step';
        step.innerHTML = '<button type="button" data-line-dec data-line-id="' + l.id + '" aria-label="One fewer ' + t + '"' + (l.quantity <= 1 ? ' disabled' : '') + '>&#8722;</button>' +
          '<b aria-live="polite">' + l.quantity + '</b>' +
          '<button type="button" data-line-inc data-line-id="' + l.id + '" aria-label="One more ' + t + '"' + (l.quantity >= max ? ' disabled' : '') + '>+</button>';
        li.appendChild(step);
        var price = document.createElement('b');
        price.className = 'ca-set-line__price';
        if (self.cardLayout && cardSave && !(l.id === freeId && !partFree)) {
          var was0 = document.createElement('s');
          was0.textContent = self.formatMoney(l.quantity * l.variant.price);
          price.appendChild(was0);
          price.appendChild(document.createTextNode(self.formatMoney(l.quantity * l.variant.price - cardSave)));
        } else if (partFree) {
          var was = document.createElement('s');
          was.textContent = self.formatMoney(l.quantity * l.variant.price);
          price.appendChild(was);
          price.appendChild(document.createTextNode(self.formatMoney(l.quantity * l.variant.price - st.saving)));
        } else {
          price.textContent = self.formatMoney(l.quantity * l.variant.price - (l.id === freeId ? st.saving : 0));
        }
        li.appendChild(price);
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'ca-set-line__remove';
        rm.setAttribute('data-line-remove', '');
        rm.setAttribute('data-line-id', l.id);
        rm.setAttribute('aria-label', 'Remove ' + self.lineName(l.variant));
        rm.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M2 2 L10 10 M10 2 L2 10"></path></svg>';
        if (single) rm.hidden = true;
        li.appendChild(rm);
        listEl.appendChild(li);
      });
    }
    if (this.sheet) {
      this.sheet.querySelectorAll('[data-ca-set-row]').forEach(function (row) {
        var q = self.set[parseInt(row.getAttribute('data-variant-id'), 10)] || 0;
        row.querySelector('[data-ca-set-qty]').textContent = q;
        row.classList.toggle('is-in-set', q > 0);
      });
      var sheetSummary = this.sheet.querySelector('[data-ca-set-sheet-summary]');
      if (sheetSummary) sheetSummary.textContent = count ? words + ' · ' + this.formatMoney(total - st.saving) + (st.saving ? ' (save ' + this.formatMoney(st.saving) + ')' : '') : 'Nothing chosen yet';
    }
  }

  // The one-line card while a sold-out color is on show: that color, marked
  // sold out, with no quantity or price; the deal line shows the offer.
  renderSoldLine() {
    var v = this.soldView;
    var box = this.querySelector('[data-ca-set-box]');
    if (box) box.hidden = false;
    this.renderCardDeal(this.dealState([]));
    var listEl = this.querySelector('[data-ca-set-lines]');
    if (!listEl) return;
    listEl.textContent = '';
    var li = document.createElement('li');
    li.className = 'ca-set-line is-sold-out';
    var thumb = document.createElement('span');
    thumb.className = 'ca-set-line__thumb';
    if (v.thumb) {
      var img = document.createElement('img');
      img.src = v.thumb;
      img.alt = '';
      img.width = 40;
      img.height = 40;
      thumb.appendChild(img);
    }
    li.appendChild(thumb);
    var name = document.createElement('span');
    name.className = 'ca-set-line__name';
    name.textContent = this.lineName(v);
    li.appendChild(name);
    var tag = document.createElement('span');
    tag.className = 'ca-set-line__soldout';
    tag.textContent = 'Sold out';
    li.appendChild(tag);
    listEl.appendChild(li);
  }

  // Products without the color list: the savings line and total under the
  // stepper.
  renderDealLine(mainLines) {
    var box = this.querySelector('[data-ca-deal-line]');
    if (!box) return;
    if (!this.deal || !this.deal.paid.length || (this.colourSet && this.setOrder.length)) { box.hidden = true; return; }
    var total = mainLines.reduce(function (t, l) { return t + l.quantity * l.price; }, 0);
    var st = this.dealState(mainLines);
    var wrap = box.querySelector('[data-ca-deal-saving]');
    this.renderSaving(st, total, box.querySelector('[data-ca-deal-saving-text]'), wrap, box.querySelector('[data-ca-deal-bar]'), null);
    box.hidden = wrap.hidden;
  }

  // Add-ons and gifts (turn 14) belong to a deal step. The rows are the
  // reached step's (the single step at one item), read from the products
  // Kaching prints beside the deal; a sold-out one is left out. Ticks and
  // chosen variants survive re-renders while the step stays the same.
  dealExtras(bar) {
    var out = { upsells: [], gifts: [] };
    if (!this.deal || !bar) return out;
    var products = this.deal.products;
    var pidOf = function (gid) { return parseInt(String(gid || '').split('/').pop(), 10); };
    bar.upsells.forEach(function (u) {
      var p = products[pidOf(u.productGID)];
      if (!p || !p.variants) return;
      var type = u.discountType || 'default';
      var value = parseFloat(u.discountValue) || 0;
      if (type !== 'percentage' && !(type === 'default' || !value)) return;
      var variants = p.variants.filter(function (v) { return v.availableForSale; });
      if (!variants.length) return;
      out.upsells.push({ id: u.id, product: p, variants: variants, rate: type === 'percentage' ? Math.min(100, value) : 0, quantity: Math.max(1, parseInt(u.quantity, 10) || 1) });
    });
    bar.gifts.forEach(function (g) {
      if (g.giftType && g.giftType !== 'product') return;
      var p = products[pidOf(g.productGID)];
      if (!p || !p.variants) return;
      var allowed = (g.variantGIDs || []).map(pidOf);
      var v = p.variants.filter(function (x) { return x.availableForSale && (!allowed.length || allowed.indexOf(x.id) >= 0); })[0];
      if (!v) return;
      out.gifts.push({ id: g.id, product: p, variant: v, quantity: Math.max(1, parseInt(g.quantity, 10) || 1) });
    });
    return out;
  }

  extrasFor(bar, qty) {
    var ex = this.dealExtras(bar);
    var self = this;
    var lines = [];
    ex.upsells.forEach(function (u) {
      if (!self.extras.checked[u.id]) return;
      var vid = self.extras.choice[u.id] || (u.variants.length === 1 ? u.variants[0].id : 0);
      var v = u.variants.filter(function (x) { return x.id === vid; })[0];
      if (!v) return;
      lines.push({ id: v.id, quantity: u.quantity, price: v.price - Math.floor(v.price * u.rate / 100), full: v.price, name: u.product.title + (u.variants.length > 1 || v.options[0] !== 'Default Title' ? ', ' + v.options.join(' / ') : ''), thumb: self.productThumb(u.product, v), kind: 'addon', upsell: u.id });
    });
    ex.gifts.forEach(function (g) {
      lines.push({ id: g.variant.id, quantity: g.quantity, price: 0, full: g.variant.price, name: g.product.title, thumb: self.productThumb(g.product, g.variant), kind: 'gift', gift: g.id });
    });
    return { rows: ex, lines: lines };
  }

  productThumb(p, v) {
    var src = (v && v.image && (v.image.src || v.image)) || p.image || '';
    return typeof src === 'string' ? src : '';
  }

  bindDealExtras() {
    var self = this;
    this.extrasBox = this.querySelector('[data-ca-deal-extras]');
    if (!this.extrasBox) return;
    this.extrasBox.addEventListener('change', function (e) {
      var check = e.target.closest('[data-ca-upsell]');
      if (check) self.extras.checked[check.getAttribute('data-ca-upsell')] = check.checked;
      var sel = e.target.closest('[data-ca-upsell-select]');
      if (sel) self.extras.choice[sel.getAttribute('data-ca-upsell-select')] = parseInt(sel.value, 10) || 0;
      self.render();
    });
    // Back from checkout after Buy now restores the page as it was left,
    // buttons still busy; clear that and re-read the cart count.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && window.CACart) {
        window.CACart.setBusy([self.atcBtn, self.stickyBtn, self.buyNowBtn], false);
        window.CACart.refreshCount();
      }
      self.resetExtras();
      self.resetComps();
      self.render();
    });
  }

  // You may also like (Abdul, 2026-09-25): Search & Discovery's related
  // products, loaded after the page through the Section Rendering API
  // (sections/ca-pdp-recs.liquid). The row stays hidden until cards arrive.
  bindRecs() {
    var self = this;
    this.recsBox = this.querySelector('[data-ca-extras]');
    this.extrasToggle = this.querySelector('[data-ca-extras-toggle]');
    this.extrasPanel = this.querySelector('[data-ca-extras-panel]');
    this.compCards = [];
    if (!this.recsBox) return;
    this.extrasToggle.addEventListener('click', function () {
      var open = self.extrasToggle.getAttribute('aria-expanded') !== 'true';
      self.extrasToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      self.extrasPanel.hidden = !open;
      self.render();
    });
    var slot = this.querySelector('[data-ca-recs-slot]');
    slot.addEventListener('change', function (e) {
      if (e.target.closest('[data-ca-comp-check], [data-ca-comp-select]')) self.render();
    });
    var url = this.recsBox.getAttribute('data-recs-url');
    if (!url || !window.fetch) return;
    fetch(url)
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        if (!html) { self.recsBox.hidden = true; return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-ca-recs]');
        if (!list) { self.recsBox.hidden = true; return; }
        Array.prototype.slice.call(list.querySelectorAll('[data-ca-comp-card]')).forEach(function (card) {
          var link = card.querySelector('a[href]');
          if (link && self.productHandle && link.getAttribute('href').indexOf('/products/' + self.productHandle) >= 0) return;
          slot.appendChild(document.importNode(card, true));
        });
        self.compCards = Array.prototype.slice.call(slot.querySelectorAll('[data-ca-comp-card]'));
        self.recsBox.hidden = self.compCards.length === 0;
        slot.classList.toggle('has-peek', self.compCards.length > 2);
        self.resetComps();
        self.render();
      })
      .catch(function () { self.recsBox.hidden = true; });
  }

  resetComps() {
    (this.compCards || []).forEach(function (card) {
      var check = card.querySelector('[data-ca-comp-check]');
      if (check) check.checked = false;
      var select = card.querySelector('[data-ca-comp-select]');
      if (select) select.selectedIndex = 0;
    });
  }

  // Ticked cards as order lines; a ticked card without its option is missing.
  compLines(lines, missing, missingItems) {
    (this.compCards || []).forEach(function (card) {
      var check = card.querySelector('[data-ca-comp-check]');
      if (!check || !check.checked) return;
      var select = card.querySelector('[data-ca-comp-select]');
      var title = card.getAttribute('data-title');
      var cardImg = card.querySelector('[data-ca-comp-img]');
      if (select) {
        var opt = select.options[select.selectedIndex];
        if (!opt || !opt.value) {
          missing.push(title);
          missingItems.push({ name: title, thumb: cardImg && cardImg.getAttribute('src'), ref: card, option: ((card.querySelector('[data-ca-comp-missing]') || {}).textContent || 'Choose an option').trim() });
          return;
        }
        lines.push({ id: opt.value, quantity: 1, price: parseInt(opt.getAttribute('data-price'), 10) || 0, name: title + ', ' + opt.textContent.trim(), thumb: opt.getAttribute('data-img') || (cardImg && cardImg.getAttribute('src')), kind: 'comp', ref: card });
      } else {
        lines.push({ id: card.getAttribute('data-variant-id'), quantity: 1, price: parseInt(card.getAttribute('data-price'), 10) || 0, name: title, thumb: cardImg && cardImg.getAttribute('src'), kind: 'comp', ref: card });
      }
    });
  }

  // Card states: the dropdown shows when ticked; a ticked card without its
  // option is outlined red with "Choose a ..." (approved v7). The row's
  // count and line say how many are in the selection.
  renderComps() {
    var self = this;
    var picked = 0;
    (this.compCards || []).forEach(function (card) {
      var on = card.querySelector('[data-ca-comp-check]').checked;
      if (on) picked += 1;
      var choice = card.querySelector('[data-ca-comp-choice]');
      var select = card.querySelector('[data-ca-comp-select]');
      if (select && on && !select.value && select.options.length === 2) select.selectedIndex = 1;
      var missing = !!(select && on && !select.value);
      if (choice) choice.hidden = !on;
      card.classList.toggle('is-selected', on);
      card.classList.toggle('is-missing', missing);
      var miss = card.querySelector('[data-ca-comp-missing]');
      if (miss) miss.hidden = !missing;
      if (select) {
        select.setAttribute('aria-invalid', missing ? 'true' : 'false');
        self.syncCompImage(card, select, on);
        var priceEl = card.querySelector('[data-ca-comp-price]');
        var opt = select.options[select.selectedIndex];
        if (priceEl) priceEl.textContent = on && opt && opt.value ? self.formatMoney(parseInt(opt.getAttribute('data-price'), 10) || 0) : priceEl.getAttribute('data-default');
      }
    });
    var open = this.extrasToggle && this.extrasToggle.getAttribute('aria-expanded') === 'true';
    var countEl = this.querySelector('[data-ca-extras-count]');
    if (countEl) {
      countEl.textContent = picked;
      countEl.hidden = open || picked === 0;
    }
    var sub = this.querySelector('[data-ca-extras-sub]');
    if (sub) sub.textContent = picked ? picked + ' added to your selection' : sub.getAttribute('data-default');
  }

  syncCompImage(card, select, on) {
    var img = card.querySelector('[data-ca-comp-img]');
    if (!img) return;
    if (!img.hasAttribute('data-default-src')) {
      img.setAttribute('data-default-src', img.getAttribute('src') || '');
      img.setAttribute('data-default-srcset', img.getAttribute('srcset') || '');
      img.setAttribute('data-default-alt', img.getAttribute('alt') || '');
    }
    var opt = select.options[select.selectedIndex];
    var chosen = on && opt && opt.value && opt.getAttribute('data-img');
    var src = chosen ? opt.getAttribute('data-img') : img.getAttribute('data-default-src');
    if (img.getAttribute('src') === src) return;
    img.setAttribute('src', src);
    img.setAttribute('srcset', chosen
      ? opt.getAttribute('data-img') + ' 300w, ' + opt.getAttribute('data-img2') + ' 600w'
      : img.getAttribute('data-default-srcset'));
    img.setAttribute('alt', chosen ? opt.getAttribute('data-alt') : img.getAttribute('data-default-alt'));
  }

  resetExtras() {
    this.extras = { barId: null, checked: {}, choice: {} };
  }

  // Draws the add-on and gift rows for the reached step; rebuilt only when
  // the step changes so a focused checkbox or select is not replaced.
  renderExtras(bar, qty) {
    var box = this.extrasBox;
    if (!box) return;
    var self = this;
    var barId = bar && qty >= 1 ? bar.id : null;
    var ex = barId ? this.dealExtras(bar) : { upsells: [], gifts: [] };
    if (barId !== this.extras.barId) {
      this.extras.barId = barId;
      this.extras.checked = {};
      box.textContent = '';
      var words = qty >= 2 && bar.threshold >= 2 ? 'your ' + bar.threshold + ' ' + this.plural(bar.threshold) : 'one ' + this.noun;
      ex.upsells.forEach(function (u) {
        var v0 = u.variants[0];
        var label = document.createElement('label');
        label.className = 'ca-deal-addon';
        var why = u.rate ? u.rate + '% off with ' + words : 'Goes with ' + words;
        var select = '';
        if (u.variants.length > 1) {
          select = '<select class="ca-deal-addon__select" data-ca-upsell-select="' + self.escapeText(u.id) + '" aria-label="' + self.escapeText(u.product.title) + ' option"><option value="">Choose</option>' +
            u.variants.map(function (v) { return '<option value="' + v.id + '">' + self.escapeText(v.options.join(' / ')) + '</option>'; }).join('') + '</select>';
        }
        var was = v0.price, now = v0.price - Math.floor(v0.price * u.rate / 100);
        var thumb = self.productThumb(u.product, v0);
        label.innerHTML = '<input type="checkbox" data-ca-upsell="' + self.escapeText(u.id) + '" autocomplete="off">' +
          '<span class="ca-deal-addon__thumb">' + (thumb ? '<img src="' + self.escapeText(thumb) + '" alt="" width="40" height="40" loading="lazy">' : '') + '</span>' +
          '<span class="ca-deal-addon__text"><b class="ca-deal-addon__name">' + self.escapeText(u.product.title) + '</b><span class="ca-deal-addon__why">' + self.escapeText(why) + '</span>' + select + '</span>' +
          '<span class="ca-deal-addon__price">' + (now < was ? '<s>' + self.formatMoney(was) + '</s>' : '') + '<b>' + self.formatMoney(now) + '</b></span>';
        box.appendChild(label);
      });
      ex.gifts.forEach(function (g) {
        var row = document.createElement('div');
        row.className = 'ca-deal-gift';
        var thumb = self.productThumb(g.product, g.variant);
        row.innerHTML = '<span class="ca-deal-addon__thumb">' + (thumb ? '<img src="' + self.escapeText(thumb) + '" alt="" width="40" height="40" loading="lazy">' : '') + '</span>' +
          '<span class="ca-deal-addon__text"><b class="ca-deal-addon__name">' + self.escapeText(g.product.title) + '</b><span class="ca-deal-gift__why">Free with ' + self.escapeText(words) + '</span></span>' +
          '<span class="ca-deal-addon__price"><s>' + self.formatMoney(g.variant.price) + '</s><b class="ca-deal-gift__free">Free</b></span>';
        box.appendChild(row);
      });
    }
    // A ticked add-on with several options needs one chosen.
    box.querySelectorAll('[data-ca-upsell-select]').forEach(function (sel) {
      var id = sel.getAttribute('data-ca-upsell-select');
      var on = !!self.extras.checked[id];
      sel.hidden = !on;
      var missing = on && !sel.value;
      sel.setAttribute('aria-invalid', missing ? 'true' : 'false');
      sel.closest('.ca-deal-addon').classList.toggle('is-missing', missing);
    });
    box.querySelectorAll('[data-ca-upsell]').forEach(function (c) {
      c.checked = !!self.extras.checked[c.getAttribute('data-ca-upsell')];
      c.closest('.ca-deal-addon').classList.toggle('is-selected', c.checked);
    });
    box.hidden = !box.childElementCount;
  }

  // Every line the main button would add, plus anything still missing.
  orderLines() {
    var self = this;
    var lines = [];
    var missing = [];
    var missingItems = [];
    if (this.soldView) return { lines: [], main: [], deal: { qty: 0, bar: null, saving: 0, next: null }, missing: [], missingItems: [] };
    var setLines = this.listMode ? this.setLines() : [];
    if (setLines.length) {
      setLines.forEach(function (l) {
        lines.push({ id: l.id, quantity: l.quantity, price: l.variant.price, name: l.variant.title, main: true, thumb: l.variant.thumb, kind: 'set' });
      });
    } else {
      var v = this.getVariant();
      var qty = this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1;
      if (v && v.available) lines.push({ id: v.id, quantity: qty, price: v.price, name: v.title, main: true, thumb: v.thumb, kind: 'main' });
    }
    var mainLines = lines.slice();
    var st = this.deal ? this.dealState(mainLines) : { qty: 0, bar: null, saving: 0, next: null };
    if (mainLines.length && this.deal) {
      var ex = this.extrasFor(st.bar, st.qty);
      ex.rows.upsells.forEach(function (u) {
        if (!self.extras.checked[u.id] || u.variants.length < 2) return;
        if (!self.extras.choice[u.id]) {
          missing.push(u.product.title);
          missingItems.push({ name: u.product.title, thumb: self.productThumb(u.product, u.variants[0]), ref: null, option: 'Choose an option' });
        }
      });
      lines = lines.concat(ex.lines);
    }
    if (mainLines.length) this.compLines(lines, missing, missingItems);
    return { lines: lines, main: mainLines, deal: st, missing: missing, missingItems: missingItems };
  }

  // What the selection costs: main lines less the deal saving, add-ons at
  // their discounted price, gifts free.
  orderTotal(order) {
    var full = order.lines.reduce(function (t, l) { return t + l.quantity * l.price; }, 0);
    return full - order.deal.saving;
  }

  renderOrder() {
    this.renderComps();
    var order = this.orderLines();
    this.renderExtras(order.deal.bar, order.deal.qty);
    this.renderDealLine(order.main);
    var count = order.lines.reduce(function (t, l) { return t + l.quantity; }, 0) + order.missing.length;
    var total = this.orderTotal(order);
    var blocked = order.missing.length > 0;
    this.renderTotal(order, count, total);
    var current = this.getVariant();
    var hasMain = order.main.length > 0;

    var label;
    if (!hasMain) label = current && !current.available ? 'Sold out' : 'Choose a color';
    else if (blocked) label = 'Choose options to add';
    else if (count === 1) label = 'Add to cart · ' + this.formatMoney(total);
    else label = 'Add to cart · ' + count + ' items · ' + this.formatMoney(total);
    var disabled = !hasMain || blocked;
    [this.atcBtn, this.stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.textContent = label;
      btn.disabled = disabled;
    });
    this.renderTray(order, count, total, hasMain, blocked);
    if (this.stickyPrice) this.stickyPrice.textContent = hasMain ? this.formatMoney(total) : '';

    // Buy now: Shopify's wallet button while the order is one line (it can
    // only carry this form's variant and quantity), our own Buy now once
    // there is more than one line.
    var single = order.lines.length === 1 && !blocked;
    if (single && this.formQty) {
      this.formQty.value = order.lines[0].quantity;
      if (this.variantInput) this.variantInput.value = order.lines[0].id;
    }
    var hasDynamic = !!(this.dynamicEl && this.dynamicEl.children.length);
    if (this.dynamicEl) this.dynamicEl.hidden = !(hasMain && single);
    if (this.buyNowBtn) {
      this.buyNowBtn.hidden = !hasMain || (single && hasDynamic);
      this.buyNowBtn.disabled = disabled;
      this.buyNowBtn.textContent = count > 1 && !blocked ? 'Buy now · ' + count + ' items' : 'Buy now';
    }

    var list = this.querySelector('[data-ca-order-lines]');
    if (list) {
      list.textContent = '';
      list.hidden = !blocked;
      if (blocked) {
        var warn = document.createElement('li');
        warn.className = 'ca-order-lines__missing';
        warn.textContent = 'Choose an option for ' + order.missing.join(', ') + '.';
        list.appendChild(warn);
      }
    }
  }

  // The one Total above Add to cart: shown once the selection is more than
  // a single item; the full price is struck through when anything saves.
  renderTotal(order, count, total) {
    var box = this.querySelector('[data-ca-order-total]');
    if (!box) return;
    var full = order.lines.reduce(function (t, l) { return t + l.quantity * (l.full != null ? l.full : l.price); }, 0);
    // One item: the button already shows the price (desktop fold, review).
    box.hidden = !order.main.length || count < 2;
    var el = box.querySelector('[data-ca-order-total-value]');
    el.textContent = '';
    if (full > total) {
      var was = document.createElement('s');
      was.className = 'ca-set-list__was';
      was.textContent = this.formatMoney(full);
      el.appendChild(was);
    }
    var now = document.createElement('b');
    now.textContent = this.formatMoney(total);
    el.appendChild(now);
  }

  clearSelection() {
    this.set = {};
    this.setOrder = [];
    if (this.qtyInput) this.qtyInput.value = 1;
    this.resetExtras();
    this.resetComps();
  }

  // Selection tray (turn 9a) and its Review sheet.
  bindTray() {
    var self = this;
    var open = this.querySelector('[data-ca-tray-open]');
    if (!this.traySheet || !open || typeof this.traySheet.showModal !== 'function') {
      if (open) open.disabled = true;
      return;
    }
    open.addEventListener('click', function () { self.traySheet.showModal(); });
    this.traySheet.addEventListener('click', function (e) {
      if (e.target === self.traySheet || e.target.closest('[data-ca-tray-close]')) { self.traySheet.close(); return; }
      var rm = e.target.closest('[data-ca-tray-remove]');
      if (rm) { self.removeTrayLine(parseInt(rm.getAttribute('data-ca-tray-remove'), 10)); return; }
      var pick = e.target.closest('[data-ca-tray-pick]');
      if (pick) {
        var card = (self.trayMissing[parseInt(pick.getAttribute('data-ca-tray-pick'), 10)] || {}).ref;
        self.traySheet.close();
        if (card && self.extrasToggle && self.extrasToggle.getAttribute('aria-expanded') !== 'true') self.extrasToggle.click();
        var sel = card ? card.querySelector('[data-ca-comp-select]') : self.querySelector('[data-ca-upsell-select]:not([hidden])');
        if (sel) { sel.scrollIntoView({ block: 'center' }); sel.focus(); }
      }
    });
    this.traySheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.traySheet.close(); }
    });
    if (this.trayAtc) this.trayAtc.addEventListener('click', function () { self.addToCart(); });
    if (this.trayBuy) this.trayBuy.addEventListener('click', function () { self.addToCart(true); });
  }

  removeTrayLine(index) {
    var line = (this.trayLines || [])[index];
    if (!line) return;
    if (line.kind === 'set') {
      delete this.set[line.id];
      this.setOrder = this.setOrder.filter(function (x) { return x !== line.id; });
    } else if (line.kind === 'addon') {
      this.extras.checked[line.upsell] = false;
    } else if (line.kind === 'comp' && line.ref) {
      var check = line.ref.querySelector('[data-ca-comp-check]');
      if (check) check.checked = false;
    }
    this.render();
    var next = this.traySheet && this.traySheet.querySelector('[data-ca-tray-remove], [data-ca-tray-close]');
    if (next) next.focus();
  }

  // Kaching's line tag (verified 2026-09-25): add-on and gift discounts
  // apply only when the lines carry it. Written only when an add-on or gift
  // is in the selection; plain lines already get the tier discount. Kaching
  // checks the tag against the cart, so a wrong step claims nothing.
  cartItems(order) {
    var deal = this.deal;
    var extra = order.lines.some(function (l) { return l.kind === 'addon' || l.kind === 'gift'; });
    if (!deal || !extra || !order.deal.bar) {
      return order.lines.filter(function (l) { return l.kind !== 'gift'; }).map(function (l) { return { id: l.id, quantity: l.quantity }; });
    }
    var group = Math.random().toString(36).slice(2, 6);
    var base = function (extraKeys) {
      var t = { id: group, deal: deal.id };
      if (deal.version) t.v = deal.version;
      for (var k in extraKeys) t[k] = extraKeys[k];
      return t;
    };
    var main = { deal: deal.id, pp: this.productId, main: true };
    if (deal.version) main.v = deal.version;
    main.id = group;
    main.bid = order.deal.bar.id;
    var parent = order.main[0] && order.main[0].id;
    return order.lines.map(function (l) {
      var item = { id: l.id, quantity: l.quantity };
      if (l.main) item.properties = { __kaching_bundles: JSON.stringify(main) };
      else if (l.kind === 'addon') item.properties = { __kaching_bundles: JSON.stringify(base({ upsell: l.upsell })) };
      else if (l.kind === 'gift') {
        item.properties = { __kaching_bundles: JSON.stringify(base({ gift: l.gift })) };
        if (parent && parent !== l.id) item.parent_id = parent;
      }
      return item;
    });
  }

  // checkout: true is Buy now; every line goes to the cart, then straight on
  // to checkout. Anything already in the cart stays there and checks out too.
  addToCart(checkout) {
    var order = this.orderLines();
    if (!order.main.length || order.missing.length) return;
    if (!window.CACart) {
      if (this.form && order.lines.length === 1) this.form.submit();
      return;
    }
    var self = this;
    var buttons = [this.atcBtn, this.stickyBtn, this.buyNowBtn, this.trayAtc, this.trayBuy].filter(Boolean);
    var inTray = !!(this.traySheet && this.traySheet.open);
    var errorEl = this.querySelector(inTray ? '[data-ca-tray-error]' : '[data-ca-pdp-cart-error]');
    var count = order.lines.reduce(function (t, l) { return t + l.quantity; }, 0);
    var total = this.orderTotal(order);
    window.CACart.showError(errorEl, '');
    window.CACart.setBusy(buttons, true);
    window.CACart.add(this.cartItems(order)).then(function () {
      if (checkout) {
        window.location.href = '/checkout';
        return;
      }
      window.CACart.setBusy(buttons, false);
      window.CACart.refreshCount();
      // The selection is in the cart now: start the next one clean so the
      // tray never counts it twice.
      self.clearSelection();
      if (self.traySheet && self.traySheet.open) self.traySheet.close();
      self.render();
      self.announceAdded(count, total);
    }, function (err) {
      window.CACart.setBusy(buttons, false);
      self.render();
      if (err && err.busy) return;
      window.CACart.showError(errorEl, err && err.message);
      if (errorEl && errorEl.getBoundingClientRect().top < 0) errorEl.scrollIntoView({ block: 'center' });
    });
  }

  // Inside Sleek (FoxTheme), its header count and cart drawer take over:
  // publish the new cart for the count and ask the drawer to refresh and
  // open. Elsewhere the page's own confirmation shows.
  announceAdded(count, total) {
    var fox = window.FoxTheme;
    if (fox && fox.pubsub && fox.pubsub.PUB_SUB_EVENTS && document.querySelector('cart-drawer')) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (cart) fox.pubsub.publish(fox.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        })
        .catch(function () {});
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      return;
    }
    this.showAdded(count, total);
  }


  // A main line's share of the deal saving, for the Review sheet: the same
  // per-unit rounding as the cart; a free unit sits on the cheapest line
  // (the last one on a tie), as in the color list.
  lineSaving(order, l) {
    var st = order.deal;
    if (!l.main || !st || !st.saving || !st.bar) return 0;
    var bar = st.bar;
    if (bar.kind === 'pct') return l.quantity * Math.floor(l.price * bar.value / 100);
    if (bar.kind === 'price') return l.quantity * Math.max(0, l.price - Math.round(bar.value * 100 / bar.threshold));
    if (bar.kind === 'free') {
      var pick = null;
      order.main.forEach(function (m) { if (!pick || m.price <= pick.price) pick = m; });
      return pick && pick.id === l.id ? st.saving : 0;
    }
    return 0;
  }

  renderTray(order, count, total, hasMain, blocked) {
    var self = this;
    this.trayLines = order.lines;
    this.trayMissing = order.missingItems || [];
    var thumbs = this.querySelector('[data-ca-tray-thumbs]');
    if (thumbs) {
      thumbs.textContent = '';
      order.lines.slice(0, 4).forEach(function (l) {
        var span = document.createElement('span');
        span.className = 'ca-tray__thumb';
        if (l.thumb) {
          var img = document.createElement('img');
          img.src = l.thumb;
          img.alt = '';
          img.width = 32;
          img.height = 32;
          span.appendChild(img);
        }
        thumbs.appendChild(span);
      });
    }
    var countEl = this.querySelector('[data-ca-tray-count]');
    if (countEl) countEl.textContent = hasMain ? '· ' + count + (count === 1 ? ' item' : ' items') : '';
    var totalEl = this.querySelector('[data-ca-tray-total]');
    if (totalEl) {
      var full = order.lines.reduce(function (t, l) { return t + l.quantity * (l.full != null ? l.full : l.price); }, 0);
      totalEl.textContent = '';
      if (full > total) {
        var was = document.createElement('s');
        was.className = 'ca-set-list__was';
        was.textContent = this.formatMoney(full);
        totalEl.appendChild(was);
        totalEl.appendChild(document.createTextNode(' '));
      }
      totalEl.appendChild(document.createTextNode(this.formatMoney(total)));
    }
    var mainLines = order.lines.filter(function (l) { return l.main; }).length;
    var list = this.querySelector('[data-ca-tray-lines]');
    if (list) {
      list.textContent = '';
      order.lines.forEach(function (l, i) {
        var li = document.createElement('li');
        li.className = 'ca-tray-line';
        li.appendChild(self.trayThumb(l.thumb));
        var text = document.createElement('span');
        text.className = 'ca-tray-line__text';
        var name = document.createElement('b');
        name.textContent = l.main ? (self.getAttribute('data-product-title') || '') + (l.name && l.name !== 'Default Title' ? ', ' + l.name : '') : l.name;
        var meta = document.createElement('span');
        meta.className = 'ca-tray-line__meta';
        meta.textContent = l.kind === 'gift' ? 'Free with your selection' : 'Qty ' + l.quantity + (l.quantity > 1 ? ' · ' + self.formatMoney(l.price) + ' each' : '');
        text.appendChild(name);
        text.appendChild(meta);
        li.appendChild(text);
        var price = document.createElement('b');
        price.className = 'ca-tray-line__price';
        var lineFull = l.quantity * (l.full != null ? l.full : l.price);
        var lineNow = l.quantity * l.price - self.lineSaving(order, l);
        if (l.kind === 'gift') {
          price.textContent = 'Free';
        } else if (lineFull > lineNow) {
          var was = document.createElement('s');
          was.textContent = self.formatMoney(lineFull);
          price.appendChild(was);
          price.appendChild(document.createTextNode(' ' + self.formatMoney(lineNow)));
        } else {
          price.textContent = self.formatMoney(lineNow);
        }
        li.appendChild(price);
        // The single main colour is the page's own product: it cannot be
        // removed here, only changed above.
        if (l.kind !== 'main' && l.kind !== 'gift' && !(l.kind === 'set' && mainLines === 1)) {
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'ca-tray-line__remove';
          rm.setAttribute('data-ca-tray-remove', i);
          rm.setAttribute('aria-label', 'Remove ' + name.textContent);
          rm.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 5h12M7 5V3.5h4V5M5 5l.7 9.5h6.6L13 5"></path></svg>';
          li.appendChild(rm);
        }
        list.appendChild(li);
      });
      this.trayMissing.forEach(function (m, i) {
        var li = document.createElement('li');
        li.className = 'ca-tray-line is-missing';
        li.appendChild(self.trayThumb(m.thumb));
        var text = document.createElement('span');
        text.className = 'ca-tray-line__text';
        var name = document.createElement('b');
        name.textContent = m.name;
        var meta = document.createElement('span');
        meta.className = 'ca-tray-line__meta';
        meta.textContent = m.option;
        text.appendChild(name);
        text.appendChild(meta);
        li.appendChild(text);
        var pick = document.createElement('button');
        pick.type = 'button';
        pick.className = 'ca-link-btn ca-tray-line__pick';
        pick.setAttribute('data-ca-tray-pick', i);
        pick.textContent = 'Choose';
        li.appendChild(pick);
        list.appendChild(li);
      });
    }
    var disabled = !hasMain || blocked;
    [this.trayAtc, this.trayBuy].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = disabled;
    });
    if (this.trayAtc) this.trayAtc.textContent = blocked ? 'Choose options to add' : 'Add to cart · ' + this.formatMoney(total);
  }

  trayThumb(src) {
    var span = document.createElement('span');
    span.className = 'ca-tray-line__thumb';
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.width = 44;
      img.height = 44;
      img.loading = 'lazy';
      span.appendChild(img);
    }
    return span;
  }

  // Free shipping progress (turn 9c): the cart after its discounts plus this
  // selection less the discount allowance, so it errs toward not free.

  bindAdded() {
    var self = this;
    this.addedPanel = this.querySelector('[data-ca-added]');
    if (!this.addedPanel) return;
    this.addedPanel.querySelectorAll('[data-ca-added-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.hideAdded(); });
    });
    this.addedPanel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.hideAdded();
    });
  }

  showAdded(count, total) {
    if (!this.addedPanel) { window.location.href = '/cart'; return; }
    var line = this.addedPanel.querySelector('[data-ca-added-line]');
    if (line) line.textContent = count + (count === 1 ? ' item' : ' items') + ', ' + this.formatMoney(total) + '.';
    this.addedPanel.hidden = false;
    var close = this.addedPanel.querySelector('[data-ca-added-close]');
    if (close) close.focus();
  }

  hideAdded() {
    if (!this.addedPanel) return;
    this.addedPanel.hidden = true;
    if (this.atcBtn) this.atcBtn.focus();
  }

  getVariant() {
    var id = this.state.variantId;
    for (var i = 0; i < this.variantsData.length; i++) {
      if (this.variantsData[i].id === id) return this.variantsData[i];
    }
    return null;
  }

  bindVariantInputs() {
    var self = this;
    this.querySelectorAll('[data-option-position]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.disabled) return;
        var position = parseInt(input.getAttribute('data-option-position'), 10);
        self.state.selectedOptions[position] = input.value;
        var matched = self.findVariantByOptions(self.state.selectedOptions);
        if (matched) self.state.variantId = matched.id;
        // In the purchase card, one line follows the color picked; with two
        // or more lines the swatches only browse (Add another color adds).
        // A sold-out color on a one-line card takes the line's place as
        // "Sold out" and nothing is buyable until an in-stock color is
        // picked, so the color on show and the buttons always agree
        // (review, 2026-09-25).
        if (self.cardLayout && matched) {
          self.soldView = !matched.available && self.setOrder.length <= 1 ? matched : null;
        }
        if (self.cardLayout && matched && matched.available && self.setOrder.length === 1 && self.setOrder[0] !== matched.id) {
          var q = self.set[self.setOrder[0]];
          self.set = {};
          self.set[matched.id] = Math.min(q, self.maxQty(matched));
          self.setOrder = [matched.id];
        }
        self.render();
        self.syncGalleryToVariant();
        self.syncRestock();
      });
    });
  }

  findVariantByOptions(selectedOptions) {
    for (var i = 0; i < this.variantsData.length; i++) {
      var variant = this.variantsData[i];
      var options = variant.options || [];
      var isMatch = true;
      for (var j = 0; j < options.length; j++) {
        if (selectedOptions[j] !== undefined && selectedOptions[j] !== options[j]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) return variant;
    }
    return null;
  }

  bindQty() {
    var input = this.qtyInput;
    var self = this;
    if (!input) return;
    input.addEventListener('change', function () {
      var val = parseInt(input.value, 10) || 1;
      if (self.colourSet && val >= 2) self.seedSet(val);
      self.render();
    });
    var dec = this.querySelector('[data-ca-qty-decrease]');
    var inc = this.querySelector('[data-ca-qty-increase]');
    if (dec) {
      dec.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = val;
        self.render();
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        var val = (parseInt(input.value, 10) || 1) + 1;
        input.value = val;
        // Turn 13b: a second lure turns the quantity into the list.
        if (self.colourSet && val >= 2) {
          self.seedSet(val);
          self.render();
          var plus = self.querySelector('[data-ca-set-lines] [data-line-inc]');
          if (plus) plus.focus();
          return;
        }
        self.render();
      });
    }
  }

  bindAtc() {
    var self = this;
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.addToCart();
      });
    }
    if (this.stickyBtn) {
      this.stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToCart();
      });
    }
    if (this.buyNowBtn) {
      this.buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToCart(true);
      });
    }
  }

  // checkout: true is Buy now; every line goes to the cart, then straight on
  // to checkout. Anything already in the cart stays there and checks out too.

  // Gallery (Abdul, 2026-09-26): one carousel on native scroll snapping.
  // Swipe on phones, arrows on desktop, a counter, and each slide's photo
  // loaded when it is reached (the next one fetched ahead), never all at
  // once. Keyboard: the arrows are buttons; with the photos focused, the
  // left and right keys move too.
  bindGallery() {
    var self = this;
    var main = this.galleryMain;
    this.currentIndex = 0;
    if (!main) return;
    this.slides = Array.prototype.slice.call(main.querySelectorAll('[data-ca-gallery-slide]'));
    this.galleryPrev = this.querySelector('[data-ca-gallery-prev]');
    this.galleryNext = this.querySelector('[data-ca-gallery-next]');
    this.galleryCounter = this.querySelector('[data-ca-gallery-counter]');
    if (this.slides.length < 2) return;
    if (this.galleryPrev) this.galleryPrev.addEventListener('click', function () { self.scrollGalleryTo(self.currentIndex - 1); });
    if (this.galleryNext) this.galleryNext.addEventListener('click', function () { self.scrollGalleryTo(self.currentIndex + 1); });
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.scrollGalleryTo(self.currentIndex + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.scrollGalleryTo(self.currentIndex - 1); }
    });
    // The slide on show follows the scroll position, whatever moved it:
    // on scrollend where the browser has it, else shortly after the last
    // scroll event (not on animation frames, which pause when the page is
    // not painting).
    var sync = function () {
      var i = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
      if (i !== self.currentIndex) self.setGalleryIndex(i);
    };
    var timer = null;
    main.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 120);
    }, { passive: true });
    main.addEventListener('scrollend', sync);
    // After the page has loaded, fetch the second photo so the first swipe
    // is instant; the rest wait until reached.
    var ahead = function () { self.hydrateSlide(1); };
    if (document.readyState === 'complete') setTimeout(ahead, 0);
    else window.addEventListener('load', ahead, { once: true });
    this.setGalleryIndex(0);
  }

  hydrateSlide(i) {
    var slide = this.slides && this.slides[i];
    if (!slide) return;
    var img = slide.querySelector('img[data-src]');
    if (!img) return;
    img.loading = 'eager';
    if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  setGalleryIndex(i) {
    var n = this.slides ? this.slides.length : 0;
    if (!n) return;
    i = Math.max(0, Math.min(n - 1, i));
    this.currentIndex = i;
    this.hydrateSlide(i);
    this.hydrateSlide(i + 1);
    if (this.galleryCounter) this.galleryCounter.textContent = (i + 1) + ' / ' + n;
    if (this.galleryPrev) this.galleryPrev.disabled = i === 0;
    if (this.galleryNext) this.galleryNext.disabled = i === n - 1;
  }

  scrollGalleryTo(index, instant) {
    if (!this.galleryMain || !this.slides || !this.slides.length) return;
    var i = Math.max(0, Math.min(this.slides.length - 1, index));
    this.hydrateSlide(i);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.galleryMain.scrollTo({ left: i * this.galleryMain.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth' });
    this.setGalleryIndex(i);
  }

  // A variant change swaps slide 1 to its photo and returns to it; the
  // marketing slides after it stay as they are.
  syncGalleryToVariant() {
    var variant = this.getVariant();
    if (!variant) return;
    if (variant.image) {
      var lead = this.querySelector('[data-ca-gallery-lead]');
      if (lead) {
        var img = lead.querySelector('img');
        if (img && img.getAttribute('src') !== variant.image.w700) {
          if (variant.image.srcset) img.srcset = variant.image.srcset;
          img.src = variant.image.w700;
          if (variant.image.width) { img.width = variant.image.width; img.height = variant.image.height; }
          img.alt = variant.image.alt || '';
        }
        lead.setAttribute('data-zoom-src', variant.image.w2000);
        lead.setAttribute('data-zoom-alt', variant.image.alt || '');
      }
    }
    this.scrollGalleryTo(0, true);
  }

  bindExpander() {
    var btn = this.querySelector('[data-ca-variant-expand]');
    var picker = this.querySelector('[data-ca-variant-picker]');
    if (!btn || !picker) return;
    btn.addEventListener('click', function () {
      picker.classList.add('is-expanded');
      btn.hidden = true;
    });
  }

  bindZoom() {
    var dialog = this.querySelector('[data-ca-zoom-dialog]');
    var openBtn = this.querySelector('[data-ca-zoom-open]');
    if (!dialog || !openBtn || typeof dialog.showModal !== 'function') {
      if (openBtn) openBtn.hidden = true;
      return;
    }
    var img = dialog.querySelector('[data-ca-zoom-img]');
    var closeBtn = dialog.querySelector('[data-ca-zoom-close]');
    var self = this;
    openBtn.addEventListener('click', function () {
      var slides = self.slides || self.querySelectorAll('[data-ca-gallery-slide]');
      var slide = slides[self.currentIndex || 0] || slides[0];
      if (!slide || !slide.getAttribute('data-zoom-src')) return;
      img.src = slide.getAttribute('data-zoom-src');
      img.alt = slide.getAttribute('data-zoom-alt') || '';
      dialog.showModal();
    });
    closeBtn.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    // The native Escape-to-close did not fire in preview testing, so close
    // on Escape explicitly rather than relying on the dialog's cancel.
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        dialog.close();
      }
    });
    dialog.addEventListener('close', function () { openBtn.focus(); });
  }

  bindStickyObserver() {
    if (!this.stickyBar || !this.atcBtn || !('IntersectionObserver' in window)) return;
    var self = this;
    // The tray shows once the Add to cart button has scrolled up out of
    // view (turn 9a), not before the shopper reaches it.
    var observer = new IntersectionObserver(function (entries) {
      var e = entries[0];
      self.stickyBar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }, { threshold: 0 });
    observer.observe(this.atcBtn);
  }

  // A complement card shows the photo of the finish chosen in its dropdown,
  // and goes back to the product photo when unticked or unchosen.

  render() {
    var variant = this.getVariant();
    if (!variant) return;
    if (this.cardLayout && !this.setOrder.length && variant.available) this.seedSet(1);
    if (window.CACart) window.CACart.showError(this.querySelector('[data-ca-pdp-cart-error]'), '');

    if (this.variantInput) this.variantInput.value = variant.id;
    if (this.priceEl) this.priceEl.textContent = variant.price_formatted;
    if (this.stickyPrice) this.stickyPrice.textContent = variant.price_formatted;
    if (this.compareEl) {
      var showCompare = variant.compare_at_price > variant.price;
      this.compareEl.hidden = !showCompare;
      if (showCompare) this.compareEl.textContent = variant.compare_at_price_formatted;
    }

    var label = variant.available ? 'Add to cart' : 'Sold out';
    [this.atcBtn, this.stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.textContent = label;
      btn.disabled = !variant.available;
    });

    if (this.inventoryEl) {
      if (!variant.available) {
        // With several colors already chosen, a sold-out color only browses:
        // say so, since the button still adds the card.
        this.inventoryEl.textContent = this.cardLayout && !this.soldView && this.setOrder.length > 1
          ? 'Out of stock. Your selection below is unchanged.'
          : 'Out of stock';
      } else if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0) {
        this.inventoryEl.textContent = 'In stock: ' + variant.inventory_quantity + ' available';
      } else {
        this.inventoryEl.textContent = 'In stock';
      }
      this.inventoryEl.classList.toggle('is-in-stock', !!variant.available);
    }
    var colourName = this.querySelector('[data-ca-colour-name]');
    if (colourName) colourName.textContent = (variant.options && variant.options[0]) || variant.title;
    var self = this;
    var qty = this.setOrder.length
      ? this.setLines().reduce(function (t, l) { return t + l.quantity; }, 0)
      : (this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1);
    this.renderDealTags(qty);
    this.syncOptionStates();
    if (this.listMode) this.renderColourSet();
    this.renderOrder();
  }
}

// Shopify's plain wallet button says "Buy it now"; the brand label is
// "Buy now" (Abdul, 2026-09-24). Shopify renders it after page load and
// may redraw it, so watch its container. The Shop Pay button is untouched.
function caRelabelBuyNow(root) {
  var box = root && root.querySelector('[data-ca-dynamic]');
  if (!box || !('MutationObserver' in window)) return;
  var fix = function () {
    var btn = box.querySelector('.shopify-payment-button__button--unbranded');
    if (btn && btn.textContent.trim() !== 'Buy now') btn.textContent = 'Buy now';
  };
  fix();
  new MutationObserver(fix).observe(box, { childList: true, subtree: true, characterData: true });
}

if (!customElements.get('ca-product-form')) {
  customElements.define('ca-product-form', CAProductForm);
}
